import { AnfrageDisplayModel } from "@/api/model-index";
import { GlobalEnumerationsAceXfoundportalobjekt } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enumerations-ace-xfoundportalobjekt";
import { AnfrageContract } from "../models/abstractions/anfrage.contract";
import { Projekt } from "../models/projekt";
import { Projektidee } from "../models/projektidee";

export class AnfrageFactory
{
    public create(anfrage: AnfrageDisplayModel): AnfrageContract | null
    {
        if (anfrage == undefined)
            return null;

        if (anfrage?.objektTyp == undefined)
            return null;

        switch(anfrage.objektTyp)
        {
            case GlobalEnumerationsAceXfoundportalobjekt.Projekt:
                return new Projekt(anfrage);
            case GlobalEnumerationsAceXfoundportalobjekt.Projektidee:
                return new Projektidee(anfrage);
            default:
                throw new Error("AnfrageFactory: AnfrageListDisplayModel.objektTyp not implemented");
        }
    }
}